import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

interface Props {
  value: boolean;
  label: string;
  onClick: () => void;
}

const Checkbox: FunctionComponent<Props> = ({ label, value, onClick }) => {
  const checkboxClassNames = classNames({
    form__checkbox: true,
    active: value,
  });

  return (
    <div className="form__row" onClick={onClick}>
      <div className={checkboxClassNames}>
        {label}
        {value}
      </div>
    </div>
  );
};

export default Checkbox;
